<template>
  <div>
    <div class="menu-wrap">
      <ul>
        <li
          :class="menuIndex == item.benefit_type ? 'active' : ''"
          @click="changeMenu(item.benefit_type)"
          :key="index"
          v-for="(item, index) in menuArr"
        >
          {{ item.name }}
        </li>
      </ul>
    </div>
    <div :class="['scroll-wrap']" v-if="data_list_by_type.length">
      <ul>
        <li
          class="welfare_block"
          v-for="(type_data, idx1) in data_list_by_type"
          :key="'type_' + idx1"
          @click="click_img(type_data)"
        >
          <div class="img-wrap">
            <img :src="type_data.head_img" alt="" />
          </div>
          <div class="info">
            <div class="left">
              <p class="title">{{ type_data.award_name }}</p>
              <span class="level">{{ type_data.sub_title }}</span>
            </div>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
import { GET_GIFT } from '../../../constant/eventbus';
import click_handler from '../../../tools/mgtv/click';
import {menuArr} from '../../../constant/class'
export default {
  name: 'FzsAward',
  props: {
    info: {
      type: Object,
      default: () => {
        return {};
      }
    },
    data_list: {
      type: Array,
      default: () => {
        return [];
      }
    }
  },
  data: function() {
    return {
      menuArr,
      menuIndex: menuArr[0].benefit_type
    };
  },
  created() {},
  methods: {
    changeMenu(index) {
      click_handler(`选择${menuArr[index % 4].name}`, () => {
        this.menuIndex = index;
      });
    },
    click_img(item) {
      click_handler(
        '领取蜂助手奖品',
        () => {
          window.$bus.$emit(GET_GIFT, {
            awardInfo: item,
            act_name: this.info.act_name
          });
        },
        {
          need_login: true
        }
      );
    }
  },
  mounted() {},
  computed: {
    user() {
      return window.$bus.user;
    },
    data_list_by_type() {
      return this.data_list.filter(item => item.benefit_type === this.menuIndex);
    }
  }
};
</script>

<style lang="stylus" scoped>
@import "../../../share/mixins.styl"
.menu-wrap
  ul
    padding: 0 0.3rem;
    height: 0.84rem;
    margin-top: -0.16rem
    li
      display: inline-flex;
      width: 25%;
      text-align: center;
      height: 100%;
      font-size: 0.32rem;
      font-weight: 400;
      color: #999999;
      line-height: 0.84rem;
      align-items: center;
      justify-content: space-around;
      position: relative
      &.active
        font-size: 0.32rem;
        font-weight: 600;
        color: #111111;
      &.active:after
        content: "";
        position: absolute;
        height: 0.04rem;
        width: 0.54rem;
        left: 50%;
        transform: translateX(-50%);
        bottom: 0;
        background: #F6C371;
.scroll-wrap
  overflow-x scroll
  overflow-y: hidden
  width: 100%
  padding-left 0.3rem
  &.white
    ul
      li
        background-color: #fff;
        box-shadow: 0px 0px 16px 0px rgba(0, 0, 0, 0.1);
        .info
          .level
            color: #D9AC63;
            background: transparent;
  ul
    margin-top: 0.16rem
    li
      height 1.48rem
      margin-right: 0.16rem
      width: 6.9rem
      overflow hidden
      position: relative
      margin-bottom: 0.16rem
      border-radius: 0.08rem
      .img-wrap
        width: 100%
        height: 100%
        overflow hidden
        position: absolute
        left: 0
        top: 0
        img
          width: 100%
      .info
        display: flex
        padding: 0.12rem
        width: 100%
        box-sizing: border-box
        position: relative
        z-index 2
        padding-left: 1.32rem
        box-sizing: border-box
        .left
          max-width: 3rem
          margin: 0.2rem 0 0 0.14rem
        .title
          height: 0.4rem;
          font-size: 0.28rem;
          font-weight: 500;
          color: #111111;
          line-height: 0.4rem;
          overflow: hidden;
          text-overflow: ellipsis
          word-break: break-all
          white-space: nowrap
        .level
          height: 0.44rem;
          font-size: 0.24rem;
          font-weight: 400;
          color: #D9AC63;
          line-height: 0.44rem;
          overflow: hidden;
          text-overflow: ellipsis
          word-break: break-all
          white-space: nowrap
          background: #FFECEC;
          border-radius: 8px;
          margin-top: 0.08rem;
          color: #F73D47;
          padding: 0 0.1rem;
          display: inline-block;
          max-width: 100%
</style>
